import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import SearchBar from './SearchBar';

import VideoList from './VideoList';
import VideoDetail from './VideoDetail';
import useVideos from '../hooks/useVideos'
const App = () =>{
  
    const [selectedVideo,setSelectedVideo] = useState(null);
   
const[videos,search] = useVideos('bollywood lofi'); //destructuring from the array that is returned from the hook
     const onVideoSelect = (video) =>{
        // console.log(video);
        setSelectedVideo(video);
        
    }
    useEffect(() => {
       setSelectedVideo(videos[0]);
    },[])

      return(
            <div className="ui container" style={{marginTop:"20px"}}>
                <SearchBar onFormSubmit={search}/>
                <VideoDetail video={selectedVideo}/>
                <VideoList videos={videos} onVideoSelect={onVideoSelect}/>
                </div>
        )
}

export default App;